import { TextField, useMediaQuery } from '@mui/material';
import { breakpoints } from '../../constants';
import { TFormValues } from '../../types';
import { Row } from '../Row';
import { useTranslation } from 'react-i18next';

interface IProps {
    formValues: TFormValues;
    getFieldError: (fieldName: keyof TFormValues) => string | undefined;
    setFieldValue(field: keyof TFormValues, value: string): void;
}

export const AddressSection = ({
    formValues,
    getFieldError,
    setFieldValue,
}: IProps) => {
    const { t } = useTranslation();
    const mediumBreakpoint = useMediaQuery(`(${breakpoints.mediumMin})`);

    return (
        <>
            <Row>
                <TextField
                    error={!!getFieldError('zipcode')}
                    helperText={getFieldError('zipcode')}
                    id={formValues.zipcode}
                    label={t('zipcode') + ' *'}
                    value={formValues.zipcode}
                    onChange={(e) => setFieldValue('zipcode', e.target.value)}
                />
                <TextField
                    error={!!getFieldError('houseNumber')}
                    helperText={getFieldError('houseNumber')}
                    id={formValues.houseNumber}
                    label={t('houseNumber') + ' *'}
                    sx={{ marginLeft: `${mediumBreakpoint && '10px'}` }}
                    value={formValues.houseNumber}
                    onChange={(e) =>
                        setFieldValue('houseNumber', e.target.value)
                    }
                />
            </Row>
            <TextField
                error={!!getFieldError('street')}
                helperText={getFieldError('street')}
                id={formValues.street}
                label={t('street') + ' *'}
                value={formValues.street}
                onChange={(e) => setFieldValue('street', e.target.value)}
            />
            <TextField
                error={!!getFieldError('city')}
                helperText={getFieldError('city')}
                id={formValues.city}
                label={t('city') + ' *'}
                value={formValues.city}
                onChange={(e) => setFieldValue('city', e.target.value)}
            />
        </>
    );
};
